<template>
  <div>
    <Card>
      <Row>
        <Button type="info" @click="add">{{
          $t("pages_banners_index_178")
        }}</Button>

        <Button type="success" style="margin-left: 10px;" :disabled="proBtn()" @click="proModalFun">{{
          $t("setting_new_1346")
        }}</Button>
      </Row>
      <TablePaginate
        :columns="columns"
        :data="taxes"
        :loading="loading"
        :meta="meta"
        :changePage="changePage"
         :onSelectionChange="onSelectionChange"
      ></TablePaginate>
    </Card>
    <Modal v-model="modalShow" @on-ok="handleSubmit" title="新增">
      <Form ref="tax" :model="tax" :label-width="150" :rules="formRules">
        <Form-item :label="$t('pages_ai_image_158')" prop="name">
          <Input type="text" v-model="tax.name" />
        </Form-item>
        <Form-item :label="$t('setting_new_1344') + '(%)'" prop="rate">
          <Input type="number" v-model="tax.rate" />
        </Form-item>
        <Form-item :label="$t('setting_new_1345')"  prop="scope">
          <Select label-in-value v-model="tax.scope">
            <Option
              v-for="item in scopes"
              :value="item.code"
              :key="item.code"
              >{{ item.text }}</Option
            >
          </Select>
        </Form-item>
        <Form-item :label="$t('setting_new_1342')"  prop="active">
          <i-switch size="large" v-model="tax.active">
            <span slot="open">{{ $t("libs_table_render_50") }}</span>
            <span slot="close">{{ $t("directives_index_41") }}</span>
          </i-switch>
        </Form-item>
      </Form>
    </Modal>

       <proModal
      :visible="proModalShow"
      @toggle="proModalFun"
      @submit="onEditPro"
    />
  </div>
</template>

<script>
import i18n from "../../locales/index";
import proModal from "./components/pro-modal";
import { mapState, mapActions, mapMutations } from "vuex";
import TablePaginate from "@/components/TablePaginate";
import { deleteButtonInTable, editorButtonInTable } from "@/libs/table-render";

export default {
  components: {
    TablePaginate,
    proModal
  },
  data() {
    return {
      proModalShow:false,
      formRules: {
        name: [{ required: true, message: i18n.t("pages_bookings_new_234") }],
        rate: [{ required: true, message: i18n.t("pages_bookings_new_234") }],
        scope: [{ required: true, message: i18n.t("pages_bookings_new_234") }],
        active: [{ required: true, message: i18n.t("pages_bookings_new_234") }],
      },
      modalShow: false,
      formType: "",
      scopes: [
        // {
        //   text: i18n.t(
        //     "pages_dashboards_statement_product_components_summary_368"
        //   ),
        //   code: "order",
        // },
        { text: i18n.t("pages_deduct_coupon_index_447"), code: "product" },
      ],
      columns: [
         {
          type: "selection",
          width: 60,
          align: "center",
        },
        {
          title: i18n.t("pages_banners_index_181"),
          key: "name",
        },
        {
          title: i18n.t("setting_new_1345"),
          key: "scope_text",
        },
        {
          title: i18n.t("setting_new_1344"),
          key: "rate",
        },
        {
          title: i18n.t("pages_ai_image_163"),
          key: "action",
          width: 200,
          align: "center",
          render: (h, params) => {
            const children = [];
            children.push(deleteButtonInTable(this, h, params));
            children.push(editorButtonInTable(this, h, params));
            return h("div", children);
          },
        },
      ],
      tax_ids: []
    };
  },
  created() {
    this.changeQuery({ page: 1 });
    this.index();
  },
  computed: {
    ...mapState("tax", ["tax", "taxes", "meta", "loading"]),
  },
  methods: {
    ...mapActions("tax", [
      "clear",
      "index",
      "show",
      "create",
      "update",
      "destroy",
    ]),
    ...mapActions('product', ["batchUpdateTaxes"]),
    ...mapMutations("tax", ["changeQuery"]),

    onSelectionChange(e){
      this.tax_ids = e.map(value=>{
        return value.id
      }) 
    },
    proBtn(){
          
        if(this.tax_ids.length == 0){
          return true
        }else{
          return false
        }
      
    },
    proModalFun(){
      this.proModalShow = !this.proModalShow
    },

    changePage(page) {
      this.changeQuery({ page: page });
      this.index();
    },

    onEditPro(e){
      this.batchUpdateTaxes({product_ids:e,tax_ids:this.tax_ids})

      this.proModalShow = false
    },
    
    add() {
      this.clear();
      this.modalShow = true;
      this.formType = "new";
    },
    async handleSubmit() {
      this.$refs.tax.validate(async (valid) => {
        if (valid) {
          if (this.formType === "edit") {
            await this.update(this.tax);
          } else if (this.formType === "new") {
            await this.create(this.tax);
          }
          this.modalShow = false;
        }
      });
    },
  },
};
</script>
